/* ws-swiper.js — dimano-style v11 (one-slide-at-a-time snap, no skipping) */
(function(){
  if (window.__wsSwiperBoundInit) return;
  window.__wsSwiperBoundInit = true;

  function bindSwiper(el) {
    if (el.__wsBound) return;
    el.__wsBound = true;
    var track = el.querySelector('.ws_swiper__track');
    var bar   = el.querySelector('.ws_swiper__bar');
    var progressEl = el.querySelector('.ws_swiper__progress');
    var count = parseInt(el.getAttribute('data-count'), 10) || 1;
    if (!track || count <= 1) return;

    var rafPending = false;
    function update() {
      rafPending = false;
      if (!bar || !progressEl) return;
      var max = track.scrollWidth - track.clientWidth;
      if (max <= 0) { bar.style.transform = 'translate3d(0,0,0)'; return; }
      var ratio = track.scrollLeft / max;
      if (ratio < 0) ratio = 0; if (ratio > 1) ratio = 1;
      var maxTranslate = progressEl.clientWidth - bar.offsetWidth;
      bar.style.transform = 'translate3d(' + (ratio * maxTranslate) + 'px,0,0)';
    }
    function schedule() {
      if (rafPending) return;
      rafPending = true;
      requestAnimationFrame(update);
    }
    track.addEventListener('scroll', schedule, { passive: true });
    track.addEventListener('touchmove', schedule, { passive: true });
    schedule();
    el.querySelectorAll('img').forEach(function(img){
      if (img.complete) return;
      img.addEventListener('load', schedule, { once: true });
    });
    if (window.ResizeObserver) {
      new ResizeObserver(schedule).observe(track);
    } else {
      window.addEventListener('resize', schedule);
    }
  }

  function bindAll() {
    document.querySelectorAll('.ws_swiper').forEach(bindSwiper);
  }

  /* Document-level mouse drag-to-scroll: capture phase, fires before any
     outer scroll-carousel listener (whether capture or bubble). */
  var dragState = null;
  var suppressClickUntil = 0;

  document.addEventListener('mousedown', function(e){
    if (e.button !== 0) return;
    var track = e.target && e.target.closest && e.target.closest('.ws_swiper__track');
    if (!track) return;
    e.stopPropagation();
    dragState = {
      track: track, startX: e.pageX, startScroll: track.scrollLeft, dragDist: 0,
      lastX: e.pageX, lastT: Date.now(), velocity: 0
    };
    track.classList.add('is-dragging');
  }, true);

  document.addEventListener('mousemove', function(e){
    if (!dragState) return;
    e.preventDefault();
    e.stopPropagation();
    var dx = e.pageX - dragState.startX;
    dragState.track.scrollLeft = dragState.startScroll - dx;
    dragState.dragDist = Math.abs(dx);
    /* track velocity over last move (px/ms, positive = next, negative = prev) */
    var now = Date.now();
    var dt = now - dragState.lastT;
    if (dt > 0) {
      dragState.velocity = (dragState.lastX - e.pageX) / dt;  /* +ve = dragging left = next slide */
    }
    dragState.lastX = e.pageX;
    dragState.lastT = now;
  }, true);

  function endDrag(e){
    if (!dragState) return;
    var track = dragState.track;
    track.classList.remove('is-dragging');
    var slideW = track.clientWidth;
    var raw = track.scrollLeft / slideW;
    var startSlide = Math.round(dragState.startScroll / slideW);
    var diff = raw - startSlide;
    var v = dragState.velocity;
    var target;
    /* one slide at a time: never skip past the immediate neighbour, regardless of how far user dragged */
    if (v > 0.4 || diff > 0.20) {
      target = startSlide + 1;
    } else if (v < -0.4 || diff < -0.20) {
      target = startSlide - 1;
    } else {
      target = startSlide;
    }
    /* clamp to valid range */
    var totalSlides = track.querySelectorAll('.ws_swiper__slide').length;
    if (target < 0) target = 0;
    if (target > totalSlides - 1) target = totalSlides - 1;
    track.scrollTo({ left: target * slideW, behavior: 'smooth' });
    if (dragState.dragDist > 5) {
      suppressClickUntil = Date.now() + 200;
    }
    dragState = null;
    if (e) e.stopPropagation();
  }
  document.addEventListener('mouseup', endDrag, true);
  document.addEventListener('mouseleave', function(e){ if (dragState) endDrag(e); }, true);
  document.addEventListener('click', function(e){
    if (Date.now() < suppressClickUntil && e.target && e.target.closest && e.target.closest('.ws_swiper__track')) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }
  /* MutationObserver picks up AJAX-injected ws_swipers (PDP related-products) */
  var mo = new MutationObserver(function(){ bindAll(); });
  mo.observe(document.body, { childList: true, subtree: true });
})();
